// "VPN" beside "Open terminal" for a personal environment its owner (or a Super Admin) may
// manage (D80); the API decides, this only hides the link where it would be refused.
import { ShieldCheck } from "@phosphor-icons/react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router";

import { accessQuery } from "../auth/access";
import { useT } from "../i18n";
import { mayOpenShell } from "../workloads/environment/shell";

export function VpnLink({ environmentId, orgId, personal }: { environmentId: string; orgId: string; personal: boolean }) {
  const t = useT().vpn;
  const me = useQuery(accessQuery());
  if (!mayOpenShell(me.data, orgId, personal)) return null;
  return (
    <Link to={`/environments/${environmentId}/vpn?org=${orgId}`} className="inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:underline">
      <ShieldCheck weight="bold" className="h-4 w-4" /> {t.title}
    </Link>
  );
}
